import React from "react"
import { connect } from "react-redux"
import { Field , getFormValues , reduxForm , SubmissionError } from "redux-form"
import {AnalyticEvent, DirectCall, SubmitButton, TextInput} from "../../../../components/forms"
import {CountryListSelectMenu} from "../../../../components/forms/countrylist-selectmenu";
import {UserRegistration} from "../../../../api/user-registration";
import {Errors} from "../../../../api/util";
import Validators from "../../../../validation";
import { OTHER_ROLE} from "../../../../api/constants";

let NewComponent = (props) => {

    return (
        <div className={"dom-newcust-myself-new"}>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section>
                    <h3>Let us know your details</h3>
                    <Field name="streetaddress" id="streetaddress" maxlength="50" placeholder="" title="Street address" component={TextInput}/>
                    <Field name="city" id="city" placeholder="" title="City" component={TextInput}/>
                    <Field name="state" id="state" placeholder="" title="State" component={TextInput}/>
                    <Field name="postcode" placeholder="" id="postcode" title="Postcode" component={TextInput}/>
                    <CountryListSelectMenu name="country" title="Country/Territory" id="country"/>
                    <SubmitButton label="SUBMIT & CONTINUE" id="dom-newcust-myself-new-btn"/>
                </section>
            </form>
        </div>
    )

};

NewComponent = connect(state => {
    let registration = getFormValues('registration')(state) ;
    let customer = getFormValues("domestic/new/customer")(state) || { country : {value:"" , label:""}}  ;
    let country = customer.country || { value : "" , label : "" };
    return {
        config : getFormValues('config')(state),
        account : getFormValues('account')(state),
        registration : {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "INDIVIDUAL",
            "individual": {
                "streetAddress": customer.streetaddress,
                "userFunctionalRole":OTHER_ROLE,
                "city": customer.city,
                "postcode": customer.postcode,
                "state": customer.state,
                "countryCode": country.value,
                "countryName": country.label
            }

        }
    }

})(reduxForm({ form : 'domestic/new/customer' ,
    destroyOnUnmount : false,
    asyncBlurFields:['streetaddress' , 'city' , 'state' , 'postcode']
})(NewComponent));

class NewCustomerContainer extends React.Component {


    render = () => {

        const handleSubmitSuccess = this.props.handleSubmitSuccess;

        return <NewComponent
            onSubmitSuccess={(result,dispatch,props) => {
                AnalyticEvent(window.dataLayer,{
                    "eventInfo": {
                        "eventName":"registrationStep4",
                        "eventAction": "2",
                    },

                    "attributes": {
                        "shippingType": "Within Australia",
                        "customerType": "My self",
                        "existingCompanyAccount": "No"
                    }
                }).then(()=> {
                    DirectCall(window._satellite, "lookupCustomerDetails")
                }, ()=> {});
                handleSubmitSuccess(result, dispatch, props)}}
            onSubmitFail={(errors,dispatch,submitErrors,props) => {
                AnalyticEvent(window.dataLayer,{
                    "eventInfo": {
                        "eventName": "registrationFailed",
                    }
                }).then(() => {
                    DirectCall(window._satellite, "registrationFailed")
                }, ()=> {});
                if((submitErrors && submitErrors.errors) || errors){
                    if(submitErrors && submitErrors.errors && (submitErrors.errors.status === 0 || submitErrors.errors.status >= 500 )){
                        dispatch(Errors.TechnicalError())
                    }
                    else if(submitErrors && submitErrors.errors && (submitErrors.errors.status >= 400 )){
                        dispatch(Errors.InvalidFormSubmission())

                    }
                    else if(errors || (submitErrors && submitErrors.errors )){
                        dispatch(Errors.InvalidFormSubmission())
                    }
                }
            }}
            onSubmit={(values,dispatch,props) => {
                dispatch(Errors.clear());
                return UserRegistration(props.config.userreg).Create(props.registration).then(
                    () => {},
                    (error) => {
                        if(error.status === 0 || error.status >= 400 ){
                            throw new SubmissionError( { status : error.status })
                        }
                        else{
                            throw new SubmissionError( { _error : error.message })
                        }
                    }
                )
            }}
            validate={(values) => {
                    return Validators.Company.validate(values);
            }}
            path={this.props.path}

            destroyOnUmount={this.props.destroyOnUnmount}
        />

    }
}

NewCustomerContainer.defaultProps = {
    destroyOnUnmount : false
};

NewCustomerContainer = connect(state => {
    return {
        config : getFormValues('config')(state),

        domestic : {
            'new' : {
                customer : getFormValues('domestic/new/customer')(state)
            }
        }
    }
})(NewCustomerContainer);

export {
    NewCustomerContainer
}